import { lazy } from 'react';

export default lazy(
  () =>
    import(
      /* webpackChunkName: "new-pricing-rule-view" */
      './CreateNewRule'
    )
);
